import React, {  useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material";
import customTheme from "./mui/theme/theme";
import "./App.css";
import AppRouter from "./routes";
import { getUserDetails } from "./utils/get-user-details";
import { useAppDispatch } from "./redux/store";
import { updateFormField } from "./redux/reducers/jobPostingSlice/jobPostingSlice";
import "../node_modules/@foundit/header/dist/HeaderWeb.css"
import HeaderLayout from "./HeaderLayout";
import { setIsLoginSuccess } from "./redux/reducers/loginSlice";
import { RecruiterDetailsResponse } from "./types";

function App() {
  const [userDetails, setUserDetails] = useState<RecruiterDetailsResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
 
  // Function to fetch user details from sessionStorage
  const fetchUserDetails = () => {
    const details = getUserDetails();
    if (details && Object.keys(details).length > 0) {
      
      setUserDetails(details);
      setIsLoading(false);
    }
  };
 
  useEffect(() => {
    if (!userDetails) {
      const intervalId = setInterval(() => {
        fetchUserDetails();
      }, 100);
 
      return () => clearInterval(intervalId);
    }
  }, [userDetails]);
 
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (userDetails) {
      dispatch(
        updateFormField({
          field: "channelId",
          value: userDetails?.channel_id,
        })
      );

      dispatch(
        updateFormField({
          field: "corpId",
          value: userDetails?.corp_id,
        })
      );

      dispatch(
        updateFormField({
          field: "siteContext",
          value: userDetails?.site_context,
        })
      );

      dispatch(
        updateFormField({
          field: "subChannelId",
          value: userDetails?.subhchannel_id,
        })
      );

      dispatch(
        updateFormField({
          field: "recruiterId",
          value: userDetails?.recruiter_id,
        })
      );
    }
  }, [userDetails]);

  const getGtmValue = (siteContext: string | undefined) => {
    switch (siteContext) {
      case "monstergulf":
        return "GTM-TGMWFHT";
      case "monstersingapore":
        return "GTM-WXW3G7";
      case "monsterthailand":
        return "GTM-W4XCF74";
      case "monsterphilippines":
        return "GTM-NCB6SR";
      case "monstervietnam":
        return "GTM-TJ7F7ZH";
      case "monstermalaysia":
        return "GTM-57CQ4N";
      case "monsterindonesia":
        return "GTM-MGZV4PL";
      case "monsterhongkong":
        return "GTM-KWGPLKK";
      case "rexmonster":
        return "GTM-NGL6ZM";
      default:
        break;
    }
  };

  useEffect(() => {
    if (userDetails) {
      const noscriptElement = document.createElement("noscript");
      const iframeElement = document.createElement("iframe");
      iframeElement.src = `https://www.googletagmanager.com/ns.html?id=${getGtmValue(
        userDetails?.site_context
      )}`;
      iframeElement.height = "0";
      iframeElement.width = "0";
      iframeElement.style.display = "none";
      iframeElement.style.visibility = "hidden";
      noscriptElement.appendChild(iframeElement);
      document.body.insertBefore(noscriptElement, document.body.firstChild);

      const scriptElement = document.createElement("script");
      scriptElement.defer = true;
      scriptElement.innerHTML = `
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer', '${getGtmValue(
        userDetails?.site_context
      )}');
    `;
      document.head.appendChild(scriptElement);
    }
  }, []);

  useEffect(()=>{
    if(userDetails){
      dispatch(setIsLoginSuccess(true));
    }
  },[userDetails]);
  return (
    <ThemeProvider theme={customTheme}>
      <HeaderLayout />
      <AppRouter
      loginError={false}
      loginData={userDetails}
      />
    </ThemeProvider>
  );
}

export default App;
